// Small helper to centralize confirm prompts and satisfy eslint in builds
export const confirmDialog = (message) => {
  if (typeof window !== 'undefined' && typeof window.confirm === 'function') {
    return window.confirm(message);
  }
  return false;
};
